import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const AuthUserSchema = z.object({
  sub: z.string(),
  name: z.string().optional(),
  nickname: z.string().optional(),
  given_name: z.string().optional(),
  family_name: z.string().optional(),
  picture: z.string().optional(),
  email: z.string().optional(),
  email_verified: z.boolean().optional(),
  org_id: z.string().optional(),
})

export type AuthUser = ZodSimplify<typeof AuthUserSchema>
